export default {
  // Active dataset: the project's default for cohorts and analytical datasets
  // created from here on. Existing ones keep the dataset they were built on,
  // which is why the switch copy says so explicitly rather than leaving the
  // action to read as though it re-points work already in the project.
  'projectPage.header.activeDatasetLabel': 'Active dataset:',
  'projectPage.header.switchDatasetButton': 'Switch dataset',
  'projectPage.header.switchDatasetDisabledTooltip':
    'You can switch the dataset once the Research Assistant has finished working.',

  'projectPage.switchDatasetModal.title': 'Switch active dataset',
  'projectPage.switchDatasetModal.dataset.label': 'Active dataset',
  'projectPage.switchDatasetModal.dataset.placeholder': 'Select a dataset',
  'projectPage.switchDatasetModal.description':
    'New cohorts and analytical datasets will be created against this dataset. Existing ones keep the dataset they were built on.',
  'projectPage.switchDatasetModal.saveButton': 'Switch dataset',
  'projectPage.switchDatasetModal.cancelButton': 'Cancel',
  'projectPage.switchDatasetModal.submitting': 'Switching dataset',
  'projectPage.switchDatasetModal.submittingError': 'Error switching dataset',
  'projectPage.switchDatasetModal.closeButton': 'Close',
  'projectPage.switchDatasetModal.success.title': 'Success',
  'projectPage.switchDatasetModal.success.text': 'The active dataset is now "{datasetName}".',

  // TODO: cleanup with skip_process_confirmation_modal ff
  'projectPage.chatPanel.composerBlocked.cohortQueuing':
    'This cohort is queuing to process — try again once it starts.',
};
